export const ActionSetPaymentDetails = ({ commit }, form) => {
  const payment_details = form;
  commit("SET_payment", payment_details);
};
